<template>
    <div :class="'bs-callout '+typeClassData">
        <h4>{{ title }}</h4>
        <!-- v-html é usado aqui para renderizar HTML dinâmico, sanitizado com DOMPurify para prevenir XSS -->
        <div v-html="sanitizedText(text)"></div>
    </div>
</template>
<script>
export default {
    name: 'info-box',
    data() {
        return { 
            typeClassData: ''
        }
    },
    props: ['type','title','text'],
    methods: {
        typeClass: function() {
            switch(this.type){
                case 'info':
                    this.typeClassData = 'bs-callout-info'
                break;
                case 'warning':
                    this.typeClassData = 'bs-callout-warning'
                break;
                case 'danger':
                    this.typeClassData = 'bs-callout-danger'
                break;
                case 'primary':
                    this.typeClassData = 'bs-callout-primary'
                break;
                default: 
                    this.typeClassData = 'bs-callout-default'
                break;
            }
        }
    },
    created(){
        this.typeClass()
    }
}
</script>
<style scoped>
    /* callouts */
    .bs-callout {
        padding: 18px;
        margin: 5px 0;
        border: 1px solid #eee;
        border-left-width: 5px;
        border-radius: 3px;
        font-weight: normal;
    }
    .bs-callout h4 {
        margin-top: 0;
        margin-bottom: 5px;
    }
    .bs-callout p:last-child {
        margin-bottom: 0;
    }
    .bs-callout code {
        border-radius: 3px;
    }
    .bs-callout+.bs-callout {
        margin-top: -5px;
    }
    .bs-callout-default {
        border-left-color: #777;
    }
    .bs-callout-default h4 {
        color: #777;
    }
    .bs-callout-primary {
        border-left-color: #428bca;
    }
    .bs-callout-primary h4 {
        color: #428bca;
    }
    .bs-callout-success {
        border-left-color: #5cb85c;
    }
    .bs-callout-success h4 {
        color: #5cb85c;
    }
    .bs-callout-danger {
        border-left-color: #d9534f;
    }
    .bs-callout-danger h4 {
        color: #d9534f;
    }
    .bs-callout-warning {
        border-left-color: #f0ad4e;
    }
    .bs-callout-warning h4 {
        color: #f0ad4e;
    }
    .bs-callout-info {
        border-left-color: #5bc0de;
    }
    .bs-callout-info h4 {
        color: #5bc0de;
    }
</style>
